// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Guadeloupe */
const GP = /^(?:(?:69(?:0\d\d|1(?:2[2-9]|3[0-5]))|7090[0-4])\d{4})$/;

export default GP;
